export const AZURE_ENTRA_ID_ROOM_CODES = [
  'entraidintroduction',
  'entraididentities',
  'entraidhybrididentities',
  'entraidexternalid',
  'entraidzerotrust',
  'entraidauthentication',
  'entraidprotection',
  'entraidgovernance',
];
